import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import useAuth from '../../../../hooks/useAuth';
import Icon from '../../../Icon';
import TheInsideLogo from '../../../svgs/TheInsideLogo';
import Cart from '../../common/Cart';

const Wrapper = styled.div`
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  background: white;
  position: relative;
  z-index: 1002;

  .contact-about-coupon-container,
  .search-login-cart-side {
    display: flex;
    align-items: center;
  }

  .container {
    display: flex;
    justify-content: space-between;
    padding: 10px;
  }

  .right-side-container,
  .left-side-container {
    width: 40%;
  }

  .logo {
    width: 33.3%;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .right-side-container,
  .left-side-container {
    display: flex;
    align-items: center;
  }

  .right-side-container {
    margin-right: 10px;
    justify-content: flex-end;
  }

  .left-side-container {
    margin-left: 10px;
    justify-content: flex-start;
  }

  .logo-nav {
    width: 80px !important;
    height: auto !important;
  }

  .nav-link,
  .search,
  .admin-btn,
  .logout {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.0007em;
    color: ${({ theme }) => theme.colors.charcoal};
    transition: 0.3s all;

    &:hover {
      color: ${({ theme }) => theme.colors.french};
    }
  }

  .search {
    cursor: pointer;
    line {
      stroke-width: 10px;
    }
    path {
      stroke-width: 10px;
    }
    transition: stroke 0.25s;
    &:hover {
      transition: stroke 0.25s;
      svg {
        line,
        path {
          stroke: #3a5bb2;
        }
      }
    }
  }

  .admin-btn,
  .logout {
    margin-right: 8px;

    a {
      color: ${({ theme }) => theme.colors.charcoal};

      &:hover {
        text-decoration: none;
      }
    }
  }

  .coupon {
    a {
      font-family: ${({ theme }) => theme.fonts.primary};
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 16px;
      display: flex;
      align-items: center;
      letter-spacing: 0.0007em;
      color: ${({ theme }) => theme.colors.charcoal};
      transition: 0.3s all;

      &:hover {
        color: ${({ theme }) => theme.colors.french};
        text-decoration: none;
      }
    }
  }
`;

function NavTop({ setShowSearch }) {
  const user = useSelector(state => state.Auth.user);
  const history = useHistory();
  const [login, logout, { loading, error, data, isAuthenticated }] = useAuth();

  const handleLogout = () => {
    logout();
    history.push(`/`);
  };

  return (
    <Wrapper>
      <div className="container">
        <div className="left-side-container">
          <div className="contact-about-coupon-container">
            <Link to="/contact" className="nav-link">
              Contact
            </Link>

            <div className="coupon">
              <div
                id="extole_zone_global_header"
                style={{ lineHeight: '10px' }}
              >
                <a href="#" className="nav-link" />
              </div>
            </div>
            <Link to="/design-trade-services" className="nav-link">
              Trade
            </Link>
            <Link to="/reviews" className="pl-0 nav-link">
              Reviews
            </Link>
            <Link to="/gift-cards" className="pl-0 nav-link">
              Gift Cards
            </Link>
          </div>
        </div>
        <div className="logo">
          <Link to="/" aria-label="The Inside">
            {/* <TheInsideLogoHolidays isScrolling={true} /> */}
            <TheInsideLogo className="logo-nav" isScrolling={true} />
          </Link>
        </div>
        <div className="right-side-container">
          <div className="search-login-cart-side">
            <div className="search" onClick={() => setShowSearch(true)}>
              <Icon icon="ti-search" size={20} color="black" className="mr-1" />
              <span>Search</span>
            </div>
            <div className="sign-in">
              <Link
                to={isAuthenticated ? '/account' : '/login'}
                className="nav-link"
                aria-label="user authentication"
              >
                {isAuthenticated ? (
                  <>
                    <Icon
                      icon="ti-account"
                      className="mr-1"
                      size={20}
                      color="black"
                    />
                    {user.first_name}
                  </>
                ) : (
                  <>
                    <Icon
                      icon="ti-account"
                      className="mr-1"
                      size={20}
                      color="black"
                    />
                    Sign In / Sign Up
                  </>
                )}
              </Link>
            </div>
            <div className="logout">
              {isAuthenticated ? (
                <a onClick={handleLogout} href="#" className="hover-orange">
                  Sign Out
                </a>
              ) : (
                ''
              )}
            </div>
            {user?.isAdmin && (
              <div className="admin-btn">
                <Link to="/admin/orders" className="hover-orange">
                  Dashboard
                </Link>
              </div>
            )}

            {user?.role_id == 3 && (
              <div className="admin-btn">
                <Link to="/supplier/orders" className="hover-orange">
                  Supplier Dashboard
                </Link>
              </div>
            )}
            <Cart />
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

export default NavTop;
